import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './utils/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Testimonials from './pages/Testimonials';
import Booking from './pages/Booking';
import PreparationGuide from './pages/PreparationGuide';
import ContractPolicies from './pages/ContractPolicies';
import MedSpa from './pages/MedSpa';
import ComingSoon from './pages/ComingSoon';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingScreen onComplete={handleLoadingComplete} />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="reviews" element={<Testimonials />} />
          <Route path="book" element={<Booking />} />
          <Route path="preparation-guide" element={<PreparationGuide />} />
          <Route path="contract-policies" element={<ContractPolicies />} />
          <Route path="med-spa" element={<MedSpa />} />
          <Route path="coming-soon" element={<ComingSoon />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
